import type { QueueSummary } from "@/lib/api";
import { formatDuration } from "@/lib/format";

interface Props {
  summary: QueueSummary | null;
  loading: boolean;
}

interface KpiCardProps {
  label: string;
  value: string;
  sublabel?: string;
}

function KpiCard({ label, value, sublabel }: KpiCardProps) {
  return (
    <div className="flex flex-col gap-1 rounded-lg border border-ink-700 bg-ink-850 px-5 py-4">
      <span className="text-xs font-medium uppercase tracking-wide text-ink-400">{label}</span>
      <span className="text-2xl font-semibold tabular-nums text-ink-100">{value}</span>
      {sublabel && <span className="text-xs text-ink-500">{sublabel}</span>}
    </div>
  );
}

export function QueueKpis({ summary, loading }: Props) {
  const dash = loading ? "…" : "—";

  const activeCount = summary
    ? ((summary.by_status["queued"] ?? 0) +
        (summary.by_status["started"] ?? 0) +
        (summary.by_status["progress"] ?? 0) +
        (summary.by_status["retry"] ?? 0))
    : null;

  const successRateStr =
    summary?.success_rate_24h != null
      ? `${(summary.success_rate_24h * 100).toFixed(1)}%`
      : dash;

  const avgDurStr =
    summary?.avg_duration_24h_seconds != null
      ? formatDuration(summary.avg_duration_24h_seconds)
      : dash;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      <KpiCard
        label="Ativos agora"
        value={activeCount != null ? String(activeCount) : dash}
        sublabel="queued + started + progress"
      />
      <KpiCard
        label="Iniciados (1 h)"
        value={summary != null ? String(summary.started_last_hour) : dash}
        sublabel="enfileirados na última hora"
      />
      <KpiCard
        label="Taxa de sucesso (24 h)"
        value={successRateStr}
        sublabel="success / (success + failure)"
      />
      <KpiCard
        label="Duração média (24 h)"
        value={avgDurStr}
        sublabel="jobs concluídos com sucesso"
      />
    </div>
  );
}
